<div class="modal-body">
  <div class="container-fluid" style="width: 100%;height: 100%;">
    <div id="header" class="row justify-content-between">
      <label
        ><span class="back" (click)="back()">
          <i
            class="fa fa-chevron-left"
            style="font-size:24px;color:blue"
          ></i> </span
        >{{ header }}</label
      >
      <div class="close-button" (click)="dialogRef.close()"></div>
    </div>
    <table id="table">
      <thead>
        <th>
          {{ sectionLabel }}
        </th>
        <th></th>
      </thead>
      <tbody>
        <tr *ngFor="let product of canAdd">
          <td
            [ngClass]="{
              active: product.isActive,
              lineskip: product.isLineskip,
              cover: product.isCover,
              drink: product.isDrink,
              other: product.isOther,
              bundle: product.isBundle
            }"
          >
            {{ product.name }}
          </td>
          <td>
            <div id="addChoiceBtn" mdbButton (click)="add(product)">
              <mdb-icon fas icon="plus" id="btn-plus"></mdb-icon>
              <p
                id="button-p"
                style="display: inline-block;font-size: 15px;cursor: pointer;"
              >
                &nbsp;Add
              </p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div id="footer" class="row justify-content-center">
      <div class="submit-button" (click)="addPass()">
        Add New Pass
      </div>
    </div>
  </div>
</div>
